import { useContext } from "react";

import BBcode from "@/utils/BBCode";
import { appDataContext } from "@/context";
import GradientWrapper from "@/components/_common/GradientWrapper";
import styled from "styled-components";

const PresentationText = () => {
  const dataContext = useContext(appDataContext);
  const text = dataContext?.lang;

  return (
    <>
      <GradientWrapper>
        <Container>
          <Content suppressHydrationWarning>
            <BBcode>{text?.presentationText.content}</BBcode>
          </Content>
        </Container>
      </GradientWrapper>
    </>
  );
};

export default PresentationText;

const Container = styled.div`
  width: 100%;
  max-width: 1224px;
  margin: 0 auto;
  padding: 0 15px;
`;

const Content = styled.p`
  color: ${(props) => props.theme.colors.blue};
  font-size: 1.8rem;
  text-align: center;

  padding: 45px 0;
  a {
    text-decoration: underline;
  }
`;
